<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Категории услуг</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте заполним категории услуг вашего проекта.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Услуги&raquo;. Если вы&nbsp;еще не&nbsp;добавляли
              услуги&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Настроить категории&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Если вы&nbsp;уже добавляли услуги&nbsp;&mdash; на&nbsp;появившейся странице нажмите &laquo;Управление
            категориями&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="dobavleniye-i-prosmotr-kategoriy"
            class="typography__headline2"
          >
            Добавление и просмотр категорий
          </FaqArticlesBlockHeading>

          <p>
            Если вы&nbsp;еще не&nbsp;добавляли категории&nbsp;&mdash; на&nbsp;появившейся странице нажмите
            &laquo;Добавить категорию&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>При добавлении первой категории можно добавить её&nbsp;только как главную категорию.</p>

            <p>Ниже нужно заполнить название и&nbsp;обложку.</p>

            <p>
              После заполнения всей информации нажмите &laquo;Добавить&raquo; в&nbsp;самом низу окна. После успешного
              добавления увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Если категории добавляли&nbsp;&mdash; попадете на&nbsp;их&nbsp;страницу.</p>

            <p>Сверху справа можно добавить новую категорию, нажав соответствующую кнопку.</p>

            <p>
              В&nbsp;списке есть важная информация о&nbsp;категориях, возможность быстро скрыть её&nbsp;с&nbsp;сайта,
              дублировать или перейти к&nbsp;редактированию или удалению.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              При добавлении очередной категории можно добавить её&nbsp;как главную категорию или как подкатегорию,
              выбрав где она будет находиться.
            </p>

            <p>Если выберите её&nbsp;подкатегорией, ниже нужно будет заполнить только название.</p>

            <p>
              После заполнения всей информации нажмите &laquo;Добавить&raquo; в&nbsp;самом низу окна. После успешного
              добавления увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После добавления подкатегории, в&nbsp;списке можно будет раскрыть иерархию категорий проекта, нажав
            на&nbsp;главную категорию со&nbsp;стрелочкой слева.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kategorii-uslug-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;категориями разобрались. Самое время перейти к&nbsp;добавлению
            <BaseLink to="/faq/articles/dobavleniye-i-redaktirovaniye-uslugi">услуг</BaseLink>.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Онлайн-&#65279;запись",
    url: "/faq/categories/onlayn-zapis",
  },
  {
    name: "Категории услуг",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Добавление&nbsp;и&nbsp;просмотр&nbsp;категорий",
    url: "dobavleniye-i-prosmotr-kategoriy",
  },
];

const relatedArticles = [
  {
    name: "Настройки записей",
    slug: "nastroyki-zapisey",
  },
  {
    name: "Добавление и&nbsp;редактирование услуги",
    slug: "dobavleniye-i-redaktirovaniye-uslugi",
  },
  {
    name: "Список услуг и&nbsp;их данные",
    slug: "spisok-uslug-i-ikh-dannye",
  },
  {
    name: "Добавление и&nbsp;редактирование записи",
    slug: "dobavlenie-i-redaktirovanie-zapisi",
  },
];

useSeoMeta({
  title: "Категории услуг",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
